<template>
  <form
    class="grid grid-cols-4 gap-4 overflow-hidden rounded-lg p-1"
    @submit="onSubmit"
  >
    <FormInputText
      name="addressLine1"
      label="Address Line 1"
      class="col-span-4"
    />
    <FormInputText
      name="addressLine2"
      label="Address Line 2"
      class="col-span-4"
    />
    <FormInputText
      name="city"
      label="City"
      class="col-span-2"
    />
    <FormInputText
      name="postcode"
      label="Postcode"
      class="col-span-2"
    />
    <div class="col-span-4 flex justify-end">
      <FormSubmitButton> Save </FormSubmitButton>
    </div>
    <template v-if="isSubmitting">
      <div class="absolute inset-0 bg-background-fg/8">
      </div>
    </template>
  </form>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { trimmedString } from "@/validation/sharedStringFieldSchemas"

const { address, setAddress } = useTenant()
const vatFormSchema = z.object({
  addressLine1: trimmedString(),
  addressLine2: trimmedString(),
  city: trimmedString(),
  postcode: trimmedString(),
})

const { handleSubmit, setValues } = useForm({
  validationSchema: toTypedSchema(vatFormSchema),
  initialValues: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    postcode: "",
  },
})

whenever(
  () => address.value,
  (value) => setValues(value),
  { immediate: true, deep: true }
)

const isSubmitting = ref(false)
const onSubmit = handleSubmit(async (params) => {
  isSubmitting.value = true
  try {
    const newVatSettings =
      await updateMerchantAddress(params)
    setAddress(newVatSettings)
    toast.success("Address updated")
  } catch (error) {
    toast.error("Failed to update address")
    throw error
  } finally {
    isSubmitting.value = false
  }
})
</script>
